export const USER_FOLLOW = 'USER_FOLLOW';
export const USER_UNFOLLOW = 'USER_UNFOLLOW';
